import { menu } from '../actions';

const initialState = {
	isOpen: false,
};

const menuReducer = (state = initialState, action) => {
	switch (action.type) {
		case menu.OPEN_MENU:
			return { ...state, isOpen: true };
		case menu.CLOSE_MENU:
			return { ...state, isOpen: false };
		default:
			return state;
	}
};

export default menuReducer;
